import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import extend from 'lodash/extend';

import NavigationBar from '../../../common/navigation-bar';
import articlesService from '../../../../services/articles';

class ArticlesNavigationBar extends Component {
  constructor(props) {
    super(props);

    const actionsData = this._generateActionsData(props.articleId);
    this.state = extend(actionsData);
  }

  componentDidMount() {
    articlesService.getFullArticles()
      .then(this._onArticlesChange)
      .catch(error => {

      });    
  }

  componentDidUpdate(props) {
    if (props.url === this.props.url) return;
    this.setState((prevState) => {
      return this._generateActionsData(props.articleId, prevState.articlesCount);
    });  
  }

  _generateActionsData(articleId, count) {
    return {
      previous: {
        link: `/articles/${this.props.prevLinkId}`,
        tooltip: 'previous article',
        isDisabled: !this.props.prevLinkId  
      },
      next: {
        link: `/articles/${this.props.nextLinkId}`,
        tooltip: 'next article',
        isDisabled: !this.props.nextLinkId  
      },
      all: {
        link: '/articles',
        tooltip: 'Back to the list',
        isDisabled: false
      },
    };
  }

  _onArticlesChange = (articles) => {
    this.setState((prevState) => {
      const newState = cloneDeep(prevState);
      newState.articlesCount = articles.length;
      newState.next.isDisabled = this._isNextDisabled(this.props.articleId, articles.length);

      return newState;
    });
  }

  _isNextDisabled(articleId, count) {
    return count === undefined || articleId >= count;
  }

  render() {
    return (
      <div className='articles-navigation-bar'>
        <NavigationBar {...this.state} />
      </div>
    );
  }  
}

ArticlesNavigationBar.propTypes = {
  articleId: PropTypes.number.isRequired,
  prevLinkId: PropTypes.string,
  nextLinkId: PropTypes.string
}

export default ArticlesNavigationBar;